import styled from 'styled-components';
import { List } from 'antd';

export const StyledList = styled(List)`
flex-direction: column;
  .ant-list-item {
    padding: 5px 0;
  }
`;

export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  background-color: #F7F7FC;
  border-radius: 3px;
`;

export const LeftDiv = styled.div`
 display: flex;
 flex-direction: column;
 flex: 1;
 margin-right: 3px;
 padding: 5px 10px;
`;

export const RightDiv = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 10px;
  background: #F1F1F1;
  border-radius: 3px;
  flex-direction: column;
  justify-content: center;
`;

export const CauseWrap = styled.div`
 display: flex;
 flex-direction: row;
 flex-wrap: wrap;
 border-bottom: 1px solid #DADADA;
 cursor: pointer;
 font-size: 1em;
 color: #4080E2;
 text-overflow: ellipsis;
 width: 100%;
 overflow: hidden;
 white-space: nowrap;
 &:hover {
  color: #0945A2;
  }
`;

export const CauseText = styled.div`
  margin-bottom: 3px;
  padding: 0px 5px;
  float: left;

  &:last-child {
    border-right: 0px;
  }
  &:first-child {
    padding-left:0px;
  }
`;

export const SubText = styled.div`
 color: rgb(134, 134, 134);
 font-size: 1em;
`;

export const SubMetricText = styled.div`
  padding-right: 5px;
  float: left;
`;

export const SubSpiText = styled.div`
  float: right;
`;

export const DimensionName = styled.div`
  float: left;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 10px;
`;

export const DimensionApp = styled.div`
  padding-right: 0px;
  float: right;
  width: 55px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SpiStreamList = styled.div`
width: 162px;
float: left;
position: absolute;
right: 0px;
`;

export const SpiValue = styled.div`
padding-right: 5px;
float: right;
`;

export const SpiStreamBlock = styled.div`
  padding-right: 5px;
  float: left;
  font-size: 16px;
`;

export const SpiStreamsValue = styled.div`
  float: left;
  width: 55px;
`;

export const SpiBlock = styled.div`
  float: left;
  padding-right: 8px;
`;

export const SpiBlockValues = styled.div`
  padding-right: 5px;
`;

export const SpiDiff = styled.div`
  position: absolute;
  right: 8px;
  svg {
    font-size: 1.2em !important;
  }
`;

export const StyledDateContainer = styled.div`
  width: 100%;
`;

export const ReleaseDate = styled.div`
  font-size: 1.0em;
  margin: 5px 0;
  color: rgb(134, 134, 134);
`;
